export const getSelection = ({ isClear = false }) => {
  const selection = window.getSelection().toString();
  return isClear ? selection.replace(/\s/g, '') : selection;
};

export default getSelection;
